import { TranslateService } from '@ngx-translate/core';
import { UserContext } from '../../../common';
import { MenuItem } from '../../../views/layout/sidebar/menu.model';

export const getNationalAddressFinderMenu: (
  userContext?: UserContext,
  translate?: TranslateService
) => MenuItem[] = (_userContext?: UserContext, translate?: TranslateService) => {
  return [
    {
      id: 16,
      label: translate ? translate.instant('MENUS.NATIONAL_ADDRESS_FINDER') : 'National Address Finder',
      icon: 'pi pi-map-marker',
      link: 'national-address-finder'
    }
  ];
};
